import { BRAND } from "@/lib/brand";
import { Award, Mic2, Radio } from "lucide-react";

const stats = [
  { icon: Award, value: "10+", label: "Years Producing" },
  { icon: Mic2, value: "5", label: "Charted Singles" },
  { icon: Radio, value: "∞", label: "Sundays Engineered" },
];

export const About = () => {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-28 lg:py-36 overflow-hidden"
    >
      <div className="absolute -left-40 top-1/2 -translate-y-1/2 w-[480px] h-[480px] rounded-full bg-brand-violet/15 blur-[160px]" />
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-12 items-center relative">
        <div className="lg:col-span-5 relative">
          <div className="relative rounded-3xl overflow-hidden border border-white/10 aspect-[4/5]">
            <img
              src="/assets/cj.jpg"
              alt={`${BRAND.producer} on the mic`}
              loading="lazy"
              decoding="async"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent" />
            <div className="absolute bottom-6 left-6 right-6">
              <p className="font-body text-[10px] uppercase tracking-[0.3em] text-brand-orange">
                Behind the Console
              </p>
              <p className="font-display font-bold text-xl text-white mt-2">
                {BRAND.producer}
              </p>
            </div>
          </div>
        </div>

        <div className="lg:col-span-7">
          <p
            data-testid="about-eyebrow"
            className="font-body text-xs uppercase tracking-[0.3em] text-brand-orange"
          >
            [ About ]
          </p>
          <h2
            data-testid="about-headline"
            className="mt-4 font-display font-black text-4xl sm:text-5xl lg:text-6xl tracking-tighter text-white"
          >
            Meet {BRAND.producer}.
          </h2>
          <div className="mt-8 space-y-5 font-body text-base lg:text-lg text-white/70 leading-relaxed max-w-2xl">
            <p>
              {BRAND.fullName} is the producer, arranger and engineer behind{" "}
              {BRAND.name}. From the keys behind the artist to the console
              behind the mix, CJ shapes records that translate — in the
              sanctuary, in the car, on the stream.
            </p>
            <p>
              His catalog spans gospel, R&B and live worship, with credits for
              Leonte J., Korey Mickie, and the Kimala M. Brady + Proclaim
              collective. Every project is treated like a release — arranged,
              tracked, mixed and mastered to chart-ready standards.
            </p>
          </div>

          <div className="mt-12 grid grid-cols-3 gap-4">
            {stats.map((s) => (
              <div
                key={s.label}
                className="rounded-2xl border border-white/10 bg-white/[0.03] p-5 lg:p-6"
              >
                <s.icon size={20} className="text-brand-magenta" />
                <p className="mt-4 font-display font-black text-2xl lg:text-3xl text-white">
                  {s.value}
                </p>
                <p className="font-body text-xs uppercase tracking-[0.18em] text-white/50 mt-1">
                  {s.label}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
